import styled from 'styled-components';

const WebsiteImageContainer = styled.div`
  box-shadow: ${({ boxShadow }) => boxShadow && '0px 15px 40px rgba(11, 26, 33, 0.1);'};
  margin: ${({ marginMobile, marginDesktop }) => marginDesktop || marginMobile};
  height: ${({ widthDesktop, widthMobile }) => widthDesktop || widthMobile};
  width: ${({ widthDesktop, widthMobile, imageSizes }) =>
    widthDesktop
      ? widthDesktop
      : widthMobile
      ? widthMobile
      : imageSizes
      ? `${imageSizes?.width}px`
      : '100%'};
  max-width: 100%;

  @media (max-width: 768px) {
    height: ${({ widthMobile }) => widthMobile};
    width: ${({ widthMobile }) => widthMobile};
  }
`;

const StyledImage = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
  width: ${({ widthDesktop, widthMobile }) => widthDesktop || widthMobile};
  margin: ${({ marginDesktop, marginMobile }) => marginDesktop || marginMobile};

  @media (max-width: 768px) {
    width: ${({ widthMobile }) => widthMobile};
    margin: ${({ marginMobile }) => marginMobile};
  }
`;

export { WebsiteImageContainer, StyledImage };
